import React from 'react';

interface SparkleIconProps {
  className?: string;
}

// Replaces the ✨ emoji literal across recommendation surfaces — renders
// consistently across platforms/fonts, unlike the emoji glyph.
const SparkleIcon: React.FC<SparkleIconProps> = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2l1.9 5.6L19.5 9.5l-5.6 1.9L12 17l-1.9-5.6L4.5 9.5l5.6-1.9L12 2z" />
    <path d="M19 13.5l.8 2.3 2.3.8-2.3.8-.8 2.3-.8-2.3-2.3-.8 2.3-.8.8-2.3z" />
  </svg>
);

export default SparkleIcon;
